import i18n from 'i18next';
import en from './en.json';
import sv from './sv.json';

i18n.addResourceBundle('en', 'leads', en);
i18n.addResourceBundle('sv', 'leads', sv);
